<template>
	<div id="app">
		<div>
			<Header :total-members="totalMembers" />
			<!--<Header v-if="$route.name !== 'results'"></Header>-->
		</div>
		<router-view />
	</div>
</template>

<style lang="scss">
</style>
<script>
	import Header from '@/components/other/header.vue'

	export default {
		components: {
			Header
		},
		data() {
			return {
				totalMembers: undefined
			}
		},
		async created() {
			let tokens = this.getCookie("tokens");
			tokens = JSON.parse(decodeURIComponent(tokens).replace(/'/g, '"'));

			if (tokens != null && tokens.authorization && tokens.refresh) {
				await localStorage.setItem("AESC_AUTH_TOKEN", tokens.authorization);
				await localStorage.setItem("AESC_REFRESH_TOKEN", tokens.refresh);

				this.$http.get("api/user/access")
					.then(resp => {
						if (resp.data == false) {
							window.location.href = process.env.VUE_APP_AESC_DOMAIN + "members/dashboard";
							return;
						}
					}).catch(err => {
						console.log(err);
					})

				await this.$http.get("api/profile/flagged")
					.then(resp => {
						if (resp.data.flagged.length > 0) {
							this.$store.dispatch('setFlaggedProfiles', resp.data);
						}
					}).catch(err => {
						console.log(err);
					})

				const login = JSON.parse(localStorage.getItem("AESC_LOGIN"));
				if (login == null || !login.user.Id) {
					this.$http.get("api/user/getLogin")
						.then(resp => {
							if (resp.data == "Could not find user.") {
								this.$buefy.toast.open("Could not find user data.");
							}
							else if (resp.data.user && resp.data.user.Id) {
								this.$store.dispatch('SetLogin', resp.data);
							}

						}).catch(err => {
							console.log(err);
						})
				}
			}
			else {
				window.location.href = process.env.VUE_APP_AESC_DOMAIN + "login?ReturnURL=" + process.env.VUE_APP_BSDB_DOMAIN;
			}


		},
		async mounted() {
			await this.getNumMembers();
			if (localStorage.getItem("BSDBCurrency")) {
				const currency = JSON.parse(localStorage.getItem("BSDBCurrency"));
				await this.tryUpdateXRate(currency.Id);
			}
		},
		methods: {
			getCookie(name) {
				var cookieArr = document.cookie.split(";");

				for (var i = 0; i < cookieArr.length; i++) {
					var cookiePair = cookieArr[i].split("=");

					if (name == cookiePair[0].trim()) {
						let tokens = "";
						if (cookiePair.length > 2) {
							cookiePair.forEach((c, index, arr) => {
								if (index > 0) {
									tokens = tokens + c;
								}
							})
							return tokens;
						}
						else
							return cookiePair[1];
					}
				}

				return null;
			},
			async tryUpdateXRate(currencyId) {
				try {
					var response = await this.$http.get("/api/currency/" + currencyId + "/rate");
					localStorage.setItem("BSDBCurrencyRate", response.data);
				}
				catch (err) {
					console.error(err);
					return Promise.reject();
				}
			},
			async getNumMembers() {
				try {
					var response = await this.$http.get("/api/user/total");
					this.totalMembers = response.data;
				}
				catch (err) {
					console.error(err);
					return Promise.reject();
				}
			}
		}
	}
</script>
